<div>
  <ng-select class="dropdown-box-component"
             [id]="dropdownBoxId"
             [ngClass]="{error: invalid}"
             [(ngModel)]="value"
             [clearable]="false"
             [searchable]="false"
             (change)="dropDownBox($event)">
    <ng-option *ngFor="let option of options" [value]="option.value">{{option.label | translate}}</ng-option>
  </ng-select>
  <div class="invalid-feedback" *ngIf="invalid">
    <span hidden [textContent]="errorText"></span>
  </div>
</div>
